var notificationSettings = [{
  key: 'sold',
  label: 'Nearby sales and marketing update',
  description: 'My properties will help you keep your finger on the property pulse with regular updates via email every month.'
}];
export default notificationSettings;